const MEASUREMENT_ID = "G-Q30CHSVBMC";

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

// Every build is the same bundle (ADR-0005), so gating happens at runtime: only acc and
// production answer under `jeugdbrandweer.nl` (infra/env/{acc,prd}.tfvars).
export function initAnalytics(hostname: string = window.location.hostname): void {
  if (!hostname.endsWith(".jeugdbrandweer.nl")) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(["js", new Date()]);
  window.dataLayer.push(["config", MEASUREMENT_ID]);
}
